export default __webpack_public_path__ + "static/media/saleb6.1a7684e2.png";